'use strict';
// jshint esversion:6
// jshint -W069


import config from './polls.config.json';
import view_polls_questionnaire from './views/questionnaire.js';
import view_polls_summary from './views/summary.js';


const module_polls_usr = {
    module_name: 'polls-usr',
    module_class: 'usr',
    title: config.usr.title,
    icon: config.usr.icon,
    redirect: config.usr.redirect,
    routes: [
        {path:'questionnaire/:poll_id/:secret', component:view_polls_questionnaire},
        {path:'results/:poll_id/:secret/:filter?', component:view_polls_summary},
    ]
};

const module_polls_mgr = {
    module_name: 'polls-mgr',
    module_class: 'mgr',
    title: config.usr.title,
    icon: config.usr.icon,
    redirect: config.mgr.redirect,
    routes: [
        {path:'summary/:poll_id/:secret/:filter?', component:view_polls_summary},
    ]
};

export default [module_polls_usr, module_polls_mgr];
